"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicSections = void 0;
var React = require("react");
var DynamicSections = /** @class */ (function (_super) {
    __extends(DynamicSections, _super);
    function DynamicSections() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.transform = function (data) {
            if (0 < data.length && !data[0]._name) {
                return _this.legacyTransform(data);
            }
            var sections = [];
            data.map(function (item, index) {
                var blockKeys = Object.keys(item).filter(function (itemKey) {
                    return itemKey.startsWith("blocks");
                });
                var blocks = blockKeys.reduce(function (allBlocks, blockKey) {
                    var _a;
                    return (__assign(__assign({}, allBlocks), (_a = {}, _a[blockKey] = (item[blockKey] || []).map(function (block, i) { return ({
                        id: i,
                        type: "default",
                        settings: block
                    }); }), _a)));
                }, {});
                var fields = item;
                sections.push(__assign({ id: index + "_" + item._name, type: "dynamic", name: item._name, settings: fields }, blocks));
            });
            return sections;
        };
        _this.legacyTransform = function (data) {
            var sections = [];
            data.map(function (item) {
                Object.keys(item).forEach(function (key) {
                    var section = item[key];
                    var blocks = section.blocks;
                    var fields = section;
                    sections.push({
                        id: key,
                        type: "dynamic",
                        name: key,
                        settings: fields,
                        blocks: blocks
                            ? blocks.map(function (block, i) { return ({
                                id: i,
                                type: "default",
                                settings: block
                            }); })
                            : []
                    });
                });
            });
            return sections;
        };
        return _this;
    }
    DynamicSections.prototype.section = function (data, i) {
        // pre code-splitting themes used an array of sections with an internal sectionId
        // post code-splitting themes use a named object hash to prevent having to load all sections
        var SectionComponent = Array.isArray(this.props.sections)
            ? this.props.sections.find(function (section) { return section.sectionId === data.name; })
            : this.props.sections[data.name];
        return SectionComponent ? (React.createElement(React.Suspense, { key: i, fallback: null },
            React.createElement(SectionComponent, __assign({ section: data }, this.props)))) : null;
    };
    DynamicSections.prototype.sections = function (sections) {
        var _this = this;
        return sections
            ? sections.map(function (section, i) { return _this.section(section, i); })
            : [];
    };
    DynamicSections.prototype.render = function () {
        return (React.createElement("main", { className: this.props.className }, this.sections(this.props.dtkSections
            ? this.transform(__spreadArrays(this.props.dtkSections))
            : this.props.data.sections)));
    };
    return DynamicSections;
}(React.Component));
exports.DynamicSections = DynamicSections;
//# sourceMappingURL=dynamic-sections.js.map